import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { Transition } from '../../../../app/spraypaint';
import { Toaster } from '../../../common/components/toasts';

export const useBankReconciliationTransition = (onSuccess?: () => void) => {
  const queryClient = useQueryClient();
  const { mutate, isLoading, ...others } = useMutation({
    mutationFn: async ({
      transitionName,
      resourceId,
      transitionParams,
    }: {
      resourceId?: string;
      toStep?: string;
      transitionName: string;
      transitionParams?: { comment: string };
    }) => {
      const transition = new Transition({
        resourceId,
        resourceType: 'Sepa::Transaction',
        transition_name: transitionName,
        transition_params: transitionParams,
      });
      const success = await transition.save();
      if (!success) {
        throw new Error('Transition failed');
      }
      if (success) {
        queryClient.invalidateQueries(['pending-sepa-transaction']);
        queryClient.invalidateQueries([
          'pending-bank-reconciliation-transactions',
        ]);
        queryClient.invalidateQueries([
          'completed-bank-reconciliation-transactions',
        ]);
        queryClient.invalidateQueries(['completed-sepa-transaction']);
        queryClient.invalidateQueries(['sepa-files']);
      }
      return { transitionName };
    },
    onSuccess: () => {
      if (onSuccess) onSuccess();
    },
    onError: () =>
      toast.error(
        <Toaster
          textMsg="Une erreur inattendu est apparu, contactez le support"
          toastType="error"
        />,
      ),
  });
  return { mutate, isLoading, ...others };
};
